import React from 'react'
import styled from '@emotion/styled'
import { Helmet } from '@dr.pogodin/react-helmet'

import { Paper, Typography } from '@mui/material'

import { useTranslation } from 'react-i18next'
import ResetPasswordComponent from '../../components/auth/ResetPassword'

const Wrapper = styled(Paper)`
    padding: ${(props) => props.theme.spacing(6)};

    ${(props) => props.theme.breakpoints.up('md')} {
        padding: ${(props) => props.theme.spacing(10)};
    }
`

function ResetPassword() {
    const { t } = useTranslation()
    return (
        <React.Fragment>
            <Wrapper>
                <Helmet title={t('pages.auth.resetPassword.helmetTitle')} />

                <Typography component='h1' variant='h4' align='center' gutterBottom>
                    {t('pages.auth.resetPassword.title')}
                </Typography>
                <Typography component='h2' variant='body1' align='center'>
                    {t('pages.auth.resetPassword.prompt')}
                </Typography>

                <ResetPasswordComponent />
            </Wrapper>
        </React.Fragment>
    )
}

export default ResetPassword
